// extracted by mini-css-extract-plugin
module.exports = {"container":"TopNavDesktop_container__8lNXP","logo":"TopNavDesktop_logo__LX8wv","siteTitle":"TopNavDesktop_siteTitle__2SApa","links":"TopNavDesktop_links__2naXG"};